module.exports = __webpack_public_path__ + "img/credito-4.721f9adb.webp";